module.exports = __webpack_public_path__ + "static/media/info_icon.79c9c52b.svg";